// /dashboard/:orgSlug/billing/cancelled — Figma frame 21 checkout cancelled (33:4061).
// Owner: screens-commerce, US-142. No Stripe anywhere in this run.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { CheckoutCancelledScreen } from "../screens/commerce/CheckoutCancelledScreen";

export const billingCancelledRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/billing/cancelled",
  staticData: { title: "Checkout cancelled" },
  component: BillingCancelledRoute,
});

function BillingCancelledRoute() {
  const { orgSlug } = billingCancelledRoute.useParams();
  return (
    <CheckoutCancelledScreen orgSlug={orgSlug} />
  );
}
